import ColorGridWithTitle from './color-grid-with-title';
export default ColorGridWithTitle;
